module.exports = __webpack_public_path__ + "static/media/Polygon 1.0d3273ea.svg";